import { interceptFetchResponse } from './intercept-fetch-response.js'

import * as mIntercom from '../modules/intercom/intercom.js'
// import * as mReferrals from '../../helpers/referrals/referrals.js'
import * as mFooter from '../modules/footer/footer.js'
import { browserAppAccount } from '../helpers/app-data-loaders/app-account.js'
import { browserAppUser } from '../helpers/app-data-loaders/app-user.js'

import '../modules/pg-header-login/index.js'
import { showPageHeaderMenu } from '../modules/header-menu/menu.js'
import { browserAppEntity } from '../helpers/app-data-loaders/app-entity.js'

// Track that User has been loaded (So navigating from one page to another does not force a reload)
let isPageLoaded = false

interceptFetchResponse(browserAppUser)

/**
 *
 * @param {Object} params
 * @param {String} [params.appAccountId] PG appAccountId
 * @param {Boolean} [params.includeEntities] PG loadEntities()
 * @param {Boolean} [params.includeCurrencies] PG loadCurrenciesForAccount()
 * @param {Boolean} [params.includeTrackings] PG loadTrackings()
 * @param {String} [params.accountingOrganisationId]
 */
export default async function appStarterPg (params = {}) {
  console.log('*** appStarterPg', params)

  mFooter.loadFooter()

  // To update for PG
  // mReferrals.readReferrer()

  // Load PG data
  await Promise.all([
    browserAppAccount.load({
      appAccountId: params.appAccountId,
      includeEntities: params.includeEntities,
      includeCurrencies: params.includeCurrencies,
      includeTrackings: params.includeTrackings
    }),
    browserAppUser.load(),
    browserAppEntity.load({
      accountingOrganisationId: params.accountingOrganisationId,
      includeTrackings: params.includeTrackings
    })
  ])

  // Identify user rights
  browserAppAccount.identifyUserRights({
    browserAppUser
  })

  // TODO: update accountData() when not on an account related page?
  showPageHeaderMenu({ browserAppAccount, browserAppUser })

  if (!isPageLoaded) {
    mIntercom.bootIntercom()
  } else {
    mIntercom.recordPage()
  }

  isPageLoaded = true
  console.log('*** appStarterPg done **')
}

// function launchGoogleAnalytics () {
//   console.log('launchGoogleAnalytics?', window.location)
//   if (window.location.hostname === 'localhost') return
//   if (window.location.hostname.includes('staging')) return

//   console.log('launch Analytics')
//   gtag('config', 'G-XXX')
// }

// launchGoogleAnalytics()
